import { Menu } from "antd";
import { Link, useHistory } from "react-router-dom";
import { buildMenuItems } from "../../../../../Constants/menuConfig"; // wherever you place the above code

const Navbar = ({ userData }) => {
  const history = useHistory();

    const handleLogout = () => {
      localStorage.clear();
      history.push("/login");
    };
      const menuItems = buildMenuItems(userData, handleLogout);

  // Recursive render for nested menus
const renderMenu = (items) =>
  items.map((item) =>
    item.children ? (
      <Menu.SubMenu key={item.key} icon={item.icon} title={item.label}>
        {renderMenu(item.children)}
      </Menu.SubMenu>
    ) : (
      <Menu.Item key={item.key} icon={item.icon} onClick={item.onClick}>
        {/* Only use Link if no onClick */}
        {item.onClick ? (
          item.label
        ) : (
          <Link to={item.path}>{item.label}</Link>
        )}
      </Menu.Item>
    )
  );


  return <Menu mode="horizontal">{renderMenu(menuItems)}</Menu>;
};

export default Navbar;
